import Button from "../../general/Button"
import { AdvertisementValue, AdvertisementsCinemasList } from "./AdvertisementComponents"

const AdvertisementListItem = ({index, item, isSingleCinema, cliCinemasIdList, cliCinemas, editItem, deleteItem}) => {
    return (
        <li className={'adverisement-item ' + (0 === index % 2 ? 'even' : 'odd')}>
            <div className="adverisement-container-values">
                <div className="advertisement-item-col even">
                    <Button
                        className="button icon button-edit button-edit-advertisement"
                        transId="edit_button"
                        onClick={()=> editItem(item.pk)}
                    />
                </div>

                <div className="advertisement-item-col odd">
                    <Button
                        className="button icon button-delete button-delete-advertisement"
                        transId="remove_button"
                        onClick={()=> deleteItem(item.pk)}
                    />
                </div>

                <div className="advertisement-item-col even">
                    <div className="advertisements-values cursor-pointer" onClick={()=> editItem(item.pk)}>
                        <AdvertisementValue 
                            value={item.title} 
                            type="text" 
                        />
                        <AdvertisementValue 
                            value={item.displayDateStart} 
                            type="date" 
                        />
                        <AdvertisementValue 
                            value={item.displayDateEnd} 
                            type="date" 
                        />
                        <AdvertisementValue 
                            value={item.link} 
                            type="check" 
                            extraClass="center" 
                        />
                        <AdvertisementValue 
                            value={item.active} 
                            type="check" 
                            extraClass="center"
                        />
                    </div>
                </div>
            </div>

            {!isSingleCinema && <AdvertisementsCinemasList
                cinemasFilter={item.cinemasFilter}
                cliCinemasIdList={cliCinemasIdList}
                cliCinemas={cliCinemas}
            />}
        </li>
    )
}

export default AdvertisementListItem